<template>
	<div class="display-flex flex-direction-row pb-100 align-items-center justify-items-center">
		<Avatar avatar-size="small" />
		<span class="display-flex flex-direction-column align-items-flex-start ml-50 delta">
			<p class="heading-6">{{ name }}</p>
			<div v-if="isProUser" class="display-flex justify-content-center align-items-center mt-25">
				<BaseLink
					v-if="!appStore.isAdvisor"
					:link="{ router: 'profile-pro-features', text: 'View Pro features' }"
					data-dd-action-name="pro cta link"
					data-test="join-pro-cta-link"
					class="button button-fundrise-pro body-xs"
				/>
			</div>
		</span>
	</div>
</template>

<script setup lang="ts">
import AdvisorAuthenticatedNav from '@classes/AdvisorAuthenticatedNav';
import AuthenticatedNav from '@classes/AuthenticatedNav';
import Avatar from '@components/avatar/avatar-component.vue';
import { computed } from 'vue';
import { useAppStore } from '@stores/app';
import { useUserStore } from '@stores/user';

interface Props {
	nav?: AuthenticatedNav | AdvisorAuthenticatedNav;
}
const props = withDefaults(defineProps<Props>(), {
	nav: undefined
});

const appStore = useAppStore();
const userStore = useUserStore();

const isProUser = computed((): boolean => userStore.isSubscriptionActive);

const name = computed((): string => {
	if (props.nav && props.nav.fullName) {
		return props.nav.fullName;
	} else {
		return 'Your Account';
	}
});
</script>
